import React from "react";
import ocakImage from "./img_8458-1024x576.webp"; // путь к коту

export default function NotFound() {
  return (
    <div
      style={{
        minHeight: "100vh",
        height: "100vh",
        width: "100vw",
        background: "#232323",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        margin: 0,
        padding: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100vw",
          height: "100vh",
          borderRadius: 0,
          overflow: "hidden",
          boxShadow: "0 6px 44px #000a",
        }}
      >
        {/* Левый блок */}
        <div
          style={{
            flex: 1,
            background: "rgba(36,36,36,0.93)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            paddingLeft: 70,
            minWidth: 330,
          }}
        >
          <h1
            style={{
              fontSize: "2.8rem",
              fontWeight: 800,
              margin: 0,
              lineHeight: 1.08,
              letterSpacing: 1.2,
              color: "#fff",
              marginBottom: 16,
            }}
          >
            СТРАНИЦА<br />НЕ РАБОТАЕТ
          </h1>
          <div
            style={{
              fontSize: "4.5rem",
              fontWeight: 800,
              color: "#3a3d3f",
              letterSpacing: 4,
              marginBottom: 14,
              marginTop: 0,
            }}
          >
            404
          </div>
          <p
            style={{
              fontSize: "1.17rem",
              color: "#bcbcbc",
              marginBottom: 40,
              marginTop: 0,
              maxWidth: 340,
            }}
          >
            Похоже, вы нашли ошибку или проблемку.<br />
            Но скоро это поправим!
          </p>
          <a
            href="/"
            style={{
              padding: "15px 38px",
              background: "#ededed",
              color: "#212121",
              borderRadius: 16,
              fontSize: "1.12rem",
              fontWeight: 600,
              textDecoration: "none",
              border: "none",
              cursor: "pointer",
              transition: "background .15s,color .15s",
              boxShadow: "0 2px 14px #0003",
              outline: "none"
            }}
            onMouseOver={e => {
              e.currentTarget.style.background = "#e95420";
              e.currentTarget.style.color = "#fff";
            }}
            onMouseOut={e => {
              e.currentTarget.style.background = "#ededed";
              e.currentTarget.style.color = "#212121";
            }}
          >
            Окак на главную
          </a>
        </div>
        {/* Правый блок: Кот */}
        <div
          style={{
            flex: 1,
            background: "#18191b",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            overflow: "hidden",
            height: "100vh",
            minWidth: 330,
          }}
        >
          <img
            src={ocakImage}
            alt="Окак мем"
            style={{
              width: "100%",
              height: "100vh",
              objectFit: "cover",
              borderRadius: 0,
              display: "block",
              filter: "brightness(1)",
              objectPosition: "center",
            }}
          />
        </div>
      </div>
      {/* Мобильная адаптация */}
      <style>{`
        @media (max-width: 900px) {
          div[style*='width: 100vw'] { flex-direction: column !important; width: 100vw !important; height: 100vh !important;}
          div[style*='min-width: 330px'] { min-width: unset !important;}
          div[style*='padding-left: 70px'] { padding-left: 12vw !important; }
          img { border-radius: 0 !important;}
        }
        @media (max-width: 600px) {
          div[style*='width: 100vw'] { width: 100vw !important; }
          div[style*='padding-left: 70px'] { padding-left: 4vw !important;}
        }
      `}</style>
    </div>
  );
}
